import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nierozliczonaKwotaText',
})
export class NierozliczonaKwotaTextPipe implements PipeTransform {
  transform(kwota: number): string {
    return kwota > 0 ? 'text-success' : '';
  }
}
